import request from "@/plugins/axios";
import {
  SplitAuditState,
  SplitAuditStateType,
  OpenInvoiceTypeLabel,
} from "../service/enum";

export class SplitService {
  static addSplitApply(params) {
    const url = "/Opencloud/Splitting/AddSplittingApply";
    return request.post(url, params);
  }
  static async getSplitApplyById(id) {
    const url = `/Opencloud/Splitting/SplittingApplyInfoById?id=${id}`;
    const res = await request.get(url);
    if (res) this.handlerApplyFields(res);
    return res;
  }
  static async getSplitApplyByCompId(compId) {
    const url = `/Opencloud/Splitting/SplittingApplyInfo?compId=${compId}`;
    const res = await request.get(url);
    if (res) this.handlerApplyFields(res);
    return res;
  }
  // 处理字段
  static handlerApplyFields(apply) {
    apply.auditStatusLabel = SplitAuditState[apply.auditStatus];
    apply.accountTypeLabel = SplitAuditStateType[apply.accountType];
    apply.openInvoiceTypeLabel = OpenInvoiceTypeLabel[apply.openInvoiceType];
    apply.openInvoiceType =
      apply.openInvoiceType == 3 ? [1, 2] : [apply.openInvoiceType];
    if (apply.approveList && apply.approveList.length) {
      apply.approveList.forEach((i) => {
        i.auditStatusLabel = SplitAuditState[i.auditStatus];
      });
    }
  }
  // 修改审批状态
  static changeSplitApplyStatus(id, type, reason) {
    let url = `/Opencloud/Splitting/AuditSplittingApply?id=${id}&type=${type}`;
    if (reason) url += `&reason=${reason}`;
    return request.post(url);
  }
  // 修改审批
  static modifySplitApply(params) {
    const url = "/Opencloud/Splitting/ModifySplittingApply";
    return request.post(url, params);
  }
}
